import React, { useEffect } from "react";
import { RestlessTable } from "../../../_metronic/layout/components/Table";
import { useDispatch, useSelector } from "react-redux";
import * as verificationActions from "../../../redux/actions/verification";
import * as imageAuthActions from "../../../redux/actions/imageAuth";
import { useSubheader } from "../../../_metronic/layout";
import RestlessImageFormatter from "../../../_metronic/layout/components/Table/RestlessImageFormatter";
import RestlessDateFormatter from "../../../_metronic/layout/components/Table/RestlessDateFormatter";
import IdentityVerificationDialog from "./RestlessIdentityVerificationDialog/IdentityVerificationDialog";
import { Route } from "react-router-dom";
import { Alert } from "react-bootstrap";
import RestlessDropdownFormatter from "../../../_metronic/layout/components/Table/RestlessDropdownFormatter";

export const IdentityVerificationPage = ({ history }) => {
  const dispatch = useDispatch();
  const suhbeader = useSubheader();
  suhbeader.setTitle("User Identity Verification");

  const STATUS = {
    verified: "verified",
    resend: "resend",
    rejected: "rejected",
  };

  const {
    listLoading,
    verificationList,
    verificationError,
    verificationStatus,
    verificationToken,
    imageToken,
  } = useSelector((state) => ({
    listLoading: state.verification.listLoading,
    verificationList: state.verification.verificationList || [],
    verificationError: state.verification.error,
    verificationStatus: state.verification.verificationStatus,
    verificationToken: state.imageAuth.verificationToken,
    imageToken: state.imageAuth.imageToken,
  }));

  const codeMethodFormatter = (cellContent) => {
    return (
      <div>{cellContent === null || cellContent === false ? "ID" : "CODE"}</div>
    );
  };

  const codeFormatter = (cellContent) => {
    return (
      <div>
        {cellContent === null || cellContent === false ? "" : cellContent}
      </div>
    );
  };

  const quickActionVerication = (e, row) => {
    e.preventDefault();
    let body;

    switch (e.target.id) {
      case "Accept":
        body = { status: STATUS.verified };
        break;
      case "Ask Again":
        body = { status: STATUS.resend };
        break;
      case "Deny":
        body = { status: STATUS.rejected };
        break;
      default:
        break;
    }
    dispatch(verificationActions.actionIdentityVerification(row.id, body));
  };
  useEffect(() => {
    dispatch(imageAuthActions.fetchVerificationImageToken());
    dispatch(imageAuthActions.fetchImageToken());
    dispatch(verificationActions.fetchVerifications());
  }, [dispatch]);

  const columns = [
    {
      dataField: "restless_user.full_name",
      text: "Member",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Register Date",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "request_date",
      text: "Request date",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "is_with_code",
      text: "Method",
      formatter: codeMethodFormatter,
      sort: true,
    },
    {
      dataField: "picture.url",
      text: "Picture",
      formatter: RestlessImageFormatter,
      formatExtraData: {
        verificationToken: verificationToken,
        openImageDialog: (imgURL) => {
          return identityUIEvents.openDetailUserDialog(imgURL);
        },
      },
    },
    {
      dataField: "restless_user.picture.url",
      text: "Profile",
      formatter: RestlessImageFormatter,
      formatExtraData: {
        profileToken: imageToken,
        openImageDialog: (imgURL) => {
          return identityUIEvents.openDetailUserDialogProfile(imgURL);
        },
      },
    },
    {
      dataField: "code",
      text: "Code",
      formatter: codeFormatter,
      sort: true,
    },
    {
      dataField: "status",
      text: "Role",
      sort: true,
    },
    {
      dataField: "action1",
      formatter: RestlessDropdownFormatter,
      formatExtraData: {
        quickActionVerication: (e, row) => {
          return quickActionVerication(e, row);
        },
        btnText: "Actions",
        actionList: [
          { key: 1, action: "Accept" },
          { key: 2, action: "Ask Again" },
          { key: 3, action: "Deny" },
        ],
      },
      headerClasses: "justify-items-center pr-3",
    },
  ];

  const identityUIEvents = {
    openDetailUserDialog: (row) => {
      history.push({
        pathname: `/identityverification/${row.id}`,
        state: { row: row },
      });
    },
    openDetailUserDialogProfile: (row) => {
      history.push({
        pathname: `/identityverification/${row.id}/profile`,
        state: { row: row },
      });
    },
  };

  const renderVerificationError = () => {
    return (
      <Alert variant="danger" className="text-center" dismissible>
        {verificationError}
      </Alert>
    );
  };

  const renderVerificationStatus = () => {
    return (
      <Alert variant="success" className="text-center" dismissible>
        {`Verification status updated, now user
        ${verificationStatus.restless_user.full_name} status is
        ${verificationStatus.status} `}
      </Alert>
    );
  };

  return (
    <div>
      {verificationStatus && renderVerificationStatus()}
      {verificationError && renderVerificationError()}
      {listLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          <Route path="/identityverification/:id">
            {({ history, match }) => (
              <IdentityVerificationDialog
                show={match != null}
                id={match && match.params.id}
                row={history.location.state?.row}
                verificationToken={verificationToken}
                onHide={() => {
                  history.push("/identityverification");
                }}
              />
            )}
          </Route>
          <Route path="/identityverification/:id/profile">
            {({ history, match }) => (
              <IdentityVerificationDialog
                show={match != null}
                id={match && match.params.id}
                row={history.location.state?.row}
                profile={history.location.state?.row}
                verificationToken={imageToken}
                onHide={() => {
                  history.push("/identityverification");
                }}
              />
            )}
          </Route>
          <div>
            <RestlessTable
              data={verificationList}
              columns={columns}
              withPagination
            />
          </div>
        </>
      )}
    </div>
  );
};
